import { PAYMENT_ACTION_TYPE } from '../../../components/syrapayHostedForm/Constants';
import { paymentMethodType } from '../constants/accountPanelConfigs';

export const getPaymentRequest = (
  amount: string,
  autoPayStatus: any,
  base_amount: string,
  individualUnitData: any,
  paymentMethod: string,
  paymentType: string,
  saveForFuture: boolean,
  surcharge_or_discount: string,
  todaysDate: string,

  // Credit Card
  card_info: {
    address1?: string;
    nameOnAccount?: string;
    cardProcessorId?: string;
    expMonth?: string;
    expYear?: string;
    zip?: string;
    token_to_save?: string;
    transaction_id?: string;
  } = {},

  // ACH
  ach_info: {
    bankName?: string;
    routingNumber?: string;
    displayAccountNumber?: string;
    encryptedAccountNumber?: string;
  } = {}
) => {
  return {
    /*  Common keys */
    amount: amount,
    amount_without_modifier: base_amount,
    effective_date: todaysDate,
    payment_method_id: paymentMethod,
    surcharge_or_discount,

    // ACH Info
    ...(paymentType == paymentMethodType.ach
      ? {
          ach_info: {
            auto_pay_enabled: autoPayStatus,
            bank_name: ach_info.bankName,
            display_account_number: ach_info.displayAccountNumber,
            encrypted_account_number: ach_info.encryptedAccountNumber,
            routing_number: ach_info.routingNumber,
            save_ach_for_future_transactions: saveForFuture,
          },
        }
      : {}),

    // Credit Card Info
    ...(paymentType == paymentMethodType.creditCard
      ? {
          action: PAYMENT_ACTION_TYPE,
          card_info: {
            billing_info: {
              name: card_info.nameOnAccount,
              address: {
                line1: card_info.address1,
                zip_code: card_info.zip,
              },
            },
            expiration_date: {
              month: card_info.expMonth,
              year: card_info.expYear,
            },
            auto_pay_enabled: autoPayStatus,
            save_card_for_future_transactions: saveForFuture,
          },
          card_processor_id: card_info.cardProcessorId,
          token_to_save: card_info.token_to_save,
          transaction_id: card_info.transaction_id,
        }
      : {}),

    tenantUserName: '',
    tenantPassword: '',
    tenantId: '',
    tenantIdFromCreationAPI: '',
    individualUnitData: individualUnitData,
  };
};

export const getDate = () => {
  let currDate = new Date();
  const offset = currDate.getTimezoneOffset();
  currDate = new Date(currDate.getTime() - offset * 60 * 1000);
  return currDate.toISOString().split('T')[0];
};

export const getPaymentMethodInfo = (paymentMethod: any, key: string) => {
  const { value, child_configuration, id } = paymentMethod;
  switch (key) {
    case 'id': {
      return child_configuration && child_configuration[0]
        ? child_configuration[0]?.id
        : id;
    }
    case 'modifier': {
      return child_configuration && child_configuration[0]
        ? child_configuration[0]?.value?.modifier
        : value?.modifier;
    }
  }
};
